import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { store } from "../redux/configStore";
import { getUserData } from "../redux/Login/Login";

/**
 * Protected route: user_token is HttpOnly — cannot read from JS.
 * Call GET /detail-user with credentials; 200 -> render, 401 -> redirect.
 */
export default function PrivativeRouterLogin() {
  const [authStatus, setAuthStatus] = useState("pending"); // pending | ok | fail
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    store
      .dispatch(getUserData())
      .then((action) => {
        if (cancelled) return;
        if (getUserData.fulfilled.match(action)) {
          setAuthStatus("ok");
        } else {
          setAuthStatus("fail");
          navigate("/login", { replace: true });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAuthStatus("fail");
          navigate("/login", { replace: true });
        }
      });
    return () => { cancelled = true; };
  }, [navigate]);

  if (authStatus === "fail") return <Navigate to="/login" replace />;
  return <Outlet />;
}
